export default "__VITE_ASSET__BLLfImmr__"